import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  list: null,
  error: null,
};

export default function UserEventsCalendar(state = InitialState, action: any) {
  switch (action.type) {
    case Action.User.Events.Calendar.SET_LIST:
      return { ...state, list: action.data };
    case Action.User.Events.Calendar.SET_STATUS:
      return { ...state, status: action.data };
    case Action.User.Events.Calendar.SET_ERROR:
      return { ...state, error: action.data };
    case Action.User.Events.Calendar.CLEAR:
      return { ...state, list: null };
    default:
      return state;
  }
}
